module.exports = __webpack_public_path__ + "img/banner3-sem lixao.1661f45b.png";